module.exports = __webpack_public_path__ + "img/wrapbg8.8c9282cd.png";